import { Box, Button, Divider, Paper, Typography, MenuItem } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useToast } from 'use-toast-mui';
import AnimationPage from '../../pages/AnimationPage';
import { errorMessages } from '../../utils/methods';
import { FormInputDropdown } from '../form/FormInputDropdown';
import { useForm } from 'react-hook-form';
import DeleteForeverIcon from '@mui/icons-material/DeleteOutline';
import { FormInputText } from '../../form-components/FormInputText';
import { createBanner } from '../../api/ticket';
import { Link, useNavigate } from 'react-router-dom';

const positionType = [
  { label: 'MAIN_01', value: 'MAIN_01' },
  { label: 'MAIN_02', value: 'MAIN_02' },
  { label: 'MAIN_03', value: 'MAIN_03' },
  { label: 'MAIN_04', value: 'MAIN_04' },
  { label: 'MAIN_05', value: 'MAIN_05' },
  { label: 'MAIN_06', value: 'MAIN_06' },
  { label: 'MAIN_07', value: 'MAIN_07' },
  { label: 'MAIN_08', value: 'MAIN_08' },
  { label: 'MAIN_09', value: 'MAIN_09' },
  { label: 'MAIN_10', value: 'MAIN_10' },
];
const statusType = [
  {
    label: 'POSTING',
    value: 'POSTING',
  },
  {
    label: 'HIDDEN',
    value: 'HIDDEN',
  },
];

const bannerType = [
  {
    label: 'BRANCH',
    value: 'BRANCH',
  },
  {
    label: 'TICKET',
    value: 'TICKET',
  },
  {
    label: 'PASS',
    value: 'PASS',
  },
  {
    label: 'ADS',
    value: 'ADS',
  },
];

const CreateBanner = () => {
  const { t } = useTranslation();

  const toast = useToast();
  const user = useSelector(state => state.user.user);
  const { handleSubmit, control, watch, getValues } = useForm();
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);

  const [videoThumbnail, setVideoThumbnail] = useState({ file: null, url: null });

  const submit = async values => {
    setLoader(true);
    const formData = new FormData();
    Object.keys(values).forEach(key => {
      formData.append(key, values[key]);
    });

    values.bannerLandingType === 'ADS' ? formData.delete('landingId') : formData.delete('landingLink');

    if (values.bannerLandingType !== 'ADS' && values.landingId && values.landingId.trim() !== '') {
        const isNotNumber = isNaN(values.landingId) || isNaN(parseFloat(values.landingId));
        if (isNotNumber) {
          toast.error(t('랜딩 링크에 올바른 링크 또는 샵/티켓 아이디를 입력해 주세요'));
          setLoader(false);
          return;
        }
    }

    // ADS 타입일 때 URL 유효성 검증
      if (values.bannerLandingType === 'ADS' && values.landingLink && values.landingLink.trim() !== '') {
        const urlPattern = /^(https?:\/\/)?([\da-z\.-]+)\.([a-z\.]{2,6})([\/\w \.-~:?#[\]@!$&'()*+,;=%]*)*\/?$/i;
        const isValidUrl = urlPattern.test(values.landingLink.trim());

        if (!isValidUrl) {
          toast.error(t('랜딩 링크에 올바른 링크 또는 샵/티켓 아이디를 입력해 주세요'));
          setLoader(false);
          return;
        }
      }



    if (videoThumbnail.file) {
      formData.append('image', videoThumbnail.file);
    } else if (videoThumbnail.url) {
      formData.append('imageString', videoThumbnail.url === null ? '' : videoThumbnail.url);
    }

    try {
      await createBanner(formData, user.token);
      toast.success(t('Banner created successfully'));
      navigate('/banner');
    } catch (error) {
      toast.error(errorMessages(error));
      setLoader(false);
    }
  };

  const deleteVideoThumbnail = e => {
    e.preventDefault();
    setVideoThumbnail({ file: null, url: null });

    const fileInput = document.getElementById('video-thumbnail');
    if (fileInput) {
      fileInput.value = '';
    }
  };

  const handleUploadVideoThumbnail = async event => {
    try {
      const file = event.target.files[0];

      if (file) {
        const validFileTypes = ['image/png', 'image/jpeg'];
        if (!validFileTypes.includes(file.type)) {
          toast.error(t('Only PNG and JPG files are allowed'));
          return;
        }

        const imageURL = URL.createObjectURL(file);
        const img = new Image();

        img.src = imageURL;

        img.onload = () => {
          if (img.width <= 686 && img.height <= 310) {
            setVideoThumbnail({ file: file, url: imageURL });
          } else {
            toast.error(t('Image exceeds the maximum allowed dimensions of 686x310'));
          }
        };
      }
    } catch (error) {
      toast.error(errorMessages(error));
    }
  };

  useEffect(() => {
    // console.log(getValues('imageText')?.length);
  }, [watch('imageText')]);
  return (
    <AnimationPage>
      <Box
        component={Paper}
        elavation={2}
        sx={{
          background: '#fff',
          borderRadius: '10px',
          padding: '30px 40px',
          width: '1080px',
        }}>
        <Box sx={{ display: 'flex', alignItems: 'center', mt: '20px' }}>
          <Typography className="title" sx={{ mr: '20px', fontSize: '12px', fontWeight: 500, width: '75px' }}>
            {t('State')}
          </Typography>
          <FormInputDropdown
            disabledItem={<MenuItem disabled>{t('전체')}</MenuItem>}
            name="status"
            rules={{ required: true }}
            control={control}
            options={statusType}
            // value={ticketData?.sportType}
            sx={{ width: '114px', mr: 2 }}
          />
        </Box>

        <Box sx={{ display: 'flex', alignItems: 'center', mt: '20px' }}>
          <Typography className="title" sx={{ mr: '20px', fontSize: '12px', fontWeight: 500, width: '75px' }}>
            {t('Position')}
          </Typography>
          <FormInputDropdown
            disabledItem={<MenuItem disabled>{t('전체')}</MenuItem>}
            name="position"
            rules={{ required: true }}
            control={control}
            options={positionType}
            // value={ticketData?.sportType}
            sx={{ width: '114px', mr: 2 }}
          />
        </Box>

        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            mt: '20px',
          }}>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Typography className="title" sx={{ mr: '20px', fontSize: '12px', fontWeight: 500, width: '75px' }}>
              {t('Title')}
            </Typography>

            <FormInputText
              color="info"
              sx={{ width: '375px' }}
              size="small"
              placeholder="제목을 입력해 주세요"
              id="outlined-search"
              type="search"
              name="title"
              rules={{ required: true }}
              control={control}
            />
          </Box>
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center', mt: '20px' }}>
          <Typography className="title" sx={{ mr: '20px', fontSize: '12px', fontWeight: 500, width: '75px' }}>
            {t('Landing Type')}
          </Typography>
          <FormInputDropdown
            disabledItem={<MenuItem disabled>{t('전체')}</MenuItem>}
            name="bannerLandingType"
            rules={{ required: true }}
            control={control}
            options={bannerType}
            // value={ticketData?.sportType}
            sx={{ width: '114px', mr: 2 }}
          />
        </Box>
        {watch('bannerLandingType') === 'ADS' ? (
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              mt: '20px',
            }}>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <Typography className="title" sx={{ mr: '20px', fontSize: '12px', fontWeight: 500, width: '75px' }}>
                {t('Landing Link')}
              </Typography>

              <FormInputText
                color="info"
                sx={{ width: '375px' }}
                size="small"
                placeholder="링크를 입력해 주세요"
                id="outlined-search"
                type="search"
                name="landingLink"
                rules={{}}
                control={control}
              />
            </Box>
          </Box>
        ) : (
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              mt: '20px',
            }}>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <Typography className="title" sx={{ mr: '20px', fontSize: '12px', fontWeight: 500, width: '75px' }}>
                {t('Landing ID')}
              </Typography>

              <FormInputText
                color="info"
                sx={{ width: '375px' }}
                size="small"
                placeholder="링크를 입력해 주세요"
                id="outlined-search"
                type="search"
                name="landingId"
                rules={{}}
                control={control}
              />
            </Box>
          </Box>
        )}

        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            mt: '20px',
          }}>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Typography sx={{ mr: '20px', fontSize: '12px', fontWeight: 500, width: '75px' }}>
              {t('Upload an image')}
            </Typography>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexDirection: 'row',
                border: '1px solid #ddd',
                height: '245px',
                width: '293px',
                mt: 1,
                mb: 1,
                borderRadius: '5px',
              }}>
              <Box
                sx={{
                  background: '#C1DBDE',
                  width: '240px',
                  height: '181px',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  overflow: 'hidden',
                }}>
                <label
                  htmlFor="video-thumbnail"
                  style={{
                    cursor: 'pointer',
                    height: '100%',
                    width: '100%',
                    position: 'relative',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}>
                  {videoThumbnail?.url || videoThumbnail?.file ? (
                    <>
                      <img src={videoThumbnail.url} style={{ height: '100%' }} />
                      <Button
                        style={{
                          position: 'absolute',
                          display: 'flex',
                          minWidth: 'unset',
                          justifyContent: 'center',
                          alignItems: 'center',
                          backgroundColor: '#fff',
                          bottom: '7px',
                          right: '7px',
                          padding: '4px',
                        }}
                        onClick={e => deleteVideoThumbnail(e)}>
                        <DeleteForeverIcon sx={{ fontSize: '20px', color: '#000' }} />
                      </Button>
                    </>
                  ) : (
                    <img src="/images/icons/image-icon.png" width={40} height={44} alt="Upload video thumbnail" />
                  )}
                </label>
                <input
                  type="file"
                  id="video-thumbnail"
                  accept="image/*"
                  style={{ display: 'none' }}
                  onChange={handleUploadVideoThumbnail}
                />
              </Box>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'flex-end', height: '100%' }}>
              <Typography sx={{ fontSize: '11px', alignSelf: 'center', ml: 1 }}>( 686 x 310px )</Typography>
            </Box>
          </Box>
        </Box>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            mt: '20px',
          }}>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Typography className="title" sx={{ mr: '20px', fontSize: '12px', fontWeight: 500, width: '75px' }}>
              {t('Image post')}
            </Typography>

            <FormInputText
              color="info"
              sx={{ width: '375px' }}
              size="small"
              placeholder="내용을 입력해 주세요"
              id="outlined-search"
              type="search"
              name="imageText"
              rules={{}}
              inputProps={{ maxLength: '15' }}
              control={control}
            />
            <Typography sx={{ fontSize: '11px', alignSelf: 'center', ml: 1 }}>
              ({getValues('imageText')?.length ?? 0}/15)
            </Typography>
          </Box>
        </Box>
        <Divider sx={{ mb: '20px', mt: '26px', color: '#e1e1e1' }} />

        <Box
          sx={{
            display: 'flex',
            mt: '10px',
            alignItems: 'center',
            justifyContent: 'flex-end',
            width: '100%',
          }}>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'end',
              columnGap: '6px',
            }}>
            <Button
              onClick={() => navigate(-1)}
              sx={{
                p: '12px 37px 11px 37px',
                borderRadius: '5px',
                height: '36px',
                width: '100px',
                background: '#98A6AD',
                color: '#fff',
                '&:hover': { background: '#ddd' },
              }}>
              {t('Cancel')}
            </Button>
            <Button
              onClick={handleSubmit(submit)}
              disabled={loader}
              sx={{
                p: '12px 56px 11px 55px',
                borderRadius: '5px',
                height: '36px',
                width: '137px',
                background: '#0F7F85',
                color: '#fff',
                '&:hover': { background: '#0F7F85', color: '#fff' },
              }}>
              {t('Save')}
            </Button>
          </Box>
        </Box>
      </Box>
    </AnimationPage>
  );
};

export default CreateBanner;
